import React from 'react'

import { Link } from 'react-router-dom'
import { routes } from '../../constants/routes'

// Most visitors deep-link straight into a form or the chef login; anyone who lands
// here picks a door — booking a chef, or the chef account side of the portal.
const Home = () => {
    return (
        <>
            <div className="full-page-bg-img" style={{ backgroundImage: 'url("/img/bg/pizza-salad.jpg")' }} />
            <div className="inquiry-landing">
                <div className="inquiry-landing__frame">
                    <div className="inquiry-landing__header">
                        <img src="/img/icons/tivity-logo.png" alt="Tivity" width="120px" />
                        <h1>Welcome to Tivity</h1>
                        <p>Book a private Chef for your next occasion, or manage your Tivity Chef account.</p>
                    </div>
                    <div className="inquiry-landing__cards">
                        <Link to={routes.inquiryIndex.path} className="inquiry-card">
                            <h2>Book a Chef</h2>
                            <p>Private dinners, multi-day stays, and weekly meals. Tell us what you need and we will match you with the best Chef within 24 hours.</p>
                            <span className="inquiry-card__cta">Book a Chef</span>
                        </Link>
                        <Link to={routes.authLogin.path} className="inquiry-card">
                            <h2>For Chefs</h2>
                            <p>Log in to manage your profile, menus, and events, or join the Tivity Chef network.</p>
                            <span className="inquiry-card__cta">Chef Login</span>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home
